var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShieldCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.283 2.217a.85.85 0 0 1 1.134 0 11.1 11.1 0 0 0 8.008 2.824.85.85 0 0 1 .866.636c.267 1.033.409 2.115.409 3.229 0 5.989-4.096 11.018-9.638 12.445a.85.85 0 0 1-.424 0C6.096 19.924 2 14.895 2 8.906c0-1.114.142-2.196.41-3.229a.85.85 0 0 1 .865-.636q.285.015.575.015c2.856 0 5.46-1.073 7.433-2.84M3.907 6.755a11.2 11.2 0 0 0-.207 2.15c0 5.119 3.449 9.433 8.15 10.743C16.551 18.338 20 14.024 20 8.906q-.002-1.106-.207-2.15a12.8 12.8 0 0 1-7.943-2.794 12.8 12.8 0 0 1-7.943 2.793m11.544 2.55a.85.85 0 0 1 0 1.202l-4 4a.85.85 0 0 1-1.202 0l-2-2a.85.85 0 0 1 1.202-1.202l1.399 1.399 3.399-3.4a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
})));
export default SvgShieldCheck;